import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../shared/api.service';

@Component({
    selector: 'ml-prompt',
    templateUrl: './ml-prompt.component.html',
    styleUrls: ['./ml-prompt.component.css']
})
export class MlPromptComponent implements OnInit {

    @Input() data?: any;

    headerPrompt: string = '';
    paragraphPrompt: string = '';

    requestRunning: boolean = false;

    constructor(private api: ApiService) { }

    ngOnInit(): void {
        this.data.acceptedHeaderIndex = -1;
        this.data.acceptedParagraphIndex = -1;
    }

    /* 
     * Header
     */

    onHeaderPromptChange(event) {
        this.headerPrompt = event;
    }

    generateHeaders(index = -1) {
        if (this.headerPrompt) {
            this.requestRunning = true;

            let n = 5;
            if (index > -1) {
                n = 1;
            }

            if (index == -1) {
                this.data.acceptedHeaderIndex = -1;
            }

            this.api.doAction('post', 'mlcontent', {
                prompt: this.headerPrompt,
                n: n,
                user: this.api.currentUserId.toString()
            }).subscribe(
                response => {
                    this.requestRunning = false;
                    if (response && response.length > 0) {
                        if (index > -1) {
                            this.data.headerResponses[index] = [response[0].trim()];
                        } else {
                            this.data.headerResponses = response.map((choice: any) => [choice.trim()]);
                        }
                    } else {
                        if (index > -1) {
                            this.data.headerResponses[index] = ['No response from the model. Please try again.'];
                        } else {
                            this.data.headerResponses = [['No response from the model. Please try again.']];
                        }
                    }

                    this.data.headerResponses = this.data.headerResponses.slice();
                }
            );
        }
    }

    acceptHeader(index) {
        this.data.acceptedHeaderIndex = index;
    }

    rejectHeader(index) {
        if (this.data.acceptedHeaderIndex == index) {
            this.data.acceptedHeaderIndex = -1;
        }
        this.generateHeaders(index);
    }

    /*
     * Paragraph
     */

    onParagraphPromptChange(event) {
        this.paragraphPrompt = event;
    }

    generateParagraph() {
        this.data.acceptedParagraphIndex = -1;

        if (this.paragraphPrompt) {
            this.requestRunning = true;
            this.api.doAction('post', 'mlcontent', {
                prompt: this.paragraphPrompt,
                n: 1
            }).subscribe(
                response => {
                    this.requestRunning = false;
                    if (response && response.length > 0) {
                        this.data.paragraphResponse = [
                            response[0]
                                .trim()
                                .replace('\n\n', '\n')
                                .split('\n')
                        ];
                    } else {
                        this.data.paragraphResponse = [
                            'No response from the model. Please try again.'
                        ];
                    }

                    this.data.paragraphResponse = this.data.paragraphResponse.slice();
                }
            );
        }
    }

    acceptParagraph(index) {
        this.data.acceptedParagraphIndex = index;
    }

    rejectParagraph(index) {
        if (this.data.acceptedParagraphIndex == index) {
            this.data.acceptedParagraphIndex = -1;
        }
        this.generateParagraph();
    }

}
